import {mapDateFormat} from 'src/utils/mapDateFormat';

import {FormattedDate} from '@pb/kit-component-formatters';


import type {Locale} from '@pb/kit-context-locale';

export const getDate = (date: string | null = null, locale: Locale) => {
    if (!date) {
        return '';
    }

    return FormattedDate.format({
        value: date,
        format: mapDateFormat(locale.dateFormat, 'NUMERIC'),
    });
};
